export const getCacheKeyWithPrefix = (cacheKey: string) => `mainsite_` + cacheKey;
